var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "beach, jetski, transportation, travel,") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "kapal layar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,22.6a2.9,2.9,0,0,1-1.66-.47,5.33,5.33,0,0,0-1-.49l2.53-5.08.06-.11h0a.83.83,0,0,0,.08-.22A.78.78,0,0,0,31,16a.69.69,0,0,0,0-.25.37.37,0,0,0,0-.14,1,1,0,0,0-.21-.32l-11-11a1,1,0,0,0-1.42,1.42L21.58,9l-2,2H6a1,1,0,0,0,0,2H20a1,1,0,0,0,.71-.29L23,10.42,27.58,15H2a1,1,0,0,0-.8.4,1,1,0,0,0-.16.87l1.53,5.36A5.16,5.16,0,0,0,1,21.4a1,1,0,0,0,0,2,2.86,2.86,0,0,1,1.65.47,4.75,4.75,0,0,0,2.63.73,4.69,4.69,0,0,0,2.63-.73,2.9,2.9,0,0,1,1.66-.47,2.86,2.86,0,0,1,1.65.47,4.75,4.75,0,0,0,2.63.73,4.75,4.75,0,0,0,2.63-.73,2.86,2.86,0,0,1,1.65-.47,2.9,2.9,0,0,1,1.66.47,5.1,5.1,0,0,0,5.26,0,3.17,3.17,0,0,1,3.32,0A4.75,4.75,0,0,0,31,24.6a1,1,0,0,0,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJets);
export default __webpack_public_path__ + "static/media/JETS.0c92f903e9eac1b7c45e896c3651f4df.svg";
export { ForwardRef as ReactComponent };